import { render, staticRenderFns } from "./CancellationDetailShipmentComponent.vue?vue&type=template&id=49fb5431"
import script from "./CancellationDetailShipmentComponent.vue?vue&type=script&lang=js"
export * from "./CancellationDetailShipmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports